import { NgModule } from "@angular/core";
import { ItemsFoundPipe } from "./items-found.pipe";

@NgModule({
    declarations: [
        ItemsFoundPipe
    ],
    exports: [
        ItemsFoundPipe
    ]
})
export class ItemsFoundModule { }